import { type FC } from 'react'
import { IntegrationIcon } from '../../../components/IntegrationIcon'
import { getSupportedProviderFromAdhocMeetingLink, PROVIDER_CONFIG, type ProviderConfig } from '../../../common/meetingProviders'
import { MeetingMode } from '../../../models/Scheduling'

// Shared virtual-meeting pill falls back to a generic "Video call" when the provider is unknown.
export const ProviderPill: FC<{ config?: ProviderConfig }> = ({ config }) => (
  <span className='d-inline-flex align-items-center zocks-gap-0.25 paragraph-small zocks-bg-color-cyan zocks-text-gray-900 rounded-3 px-2 py-1'>
    {config ? <IntegrationIcon serviceId={config.serviceId} width={16} height={16} /> : <i className='bi bi-camera-video' aria-hidden='true' />}
    {config?.label ?? 'Video call'}
  </span>
)

interface ProviderBadgeProps {
  meetingMode?: MeetingMode
  meetingUrl?: string
}

export const ProviderBadge: FC<ProviderBadgeProps> = ({ meetingMode, meetingUrl }) => {
  if (meetingMode === MeetingMode.IN_PERSON) {
    return <span className='paragraph-small zocks-bg-color-warning zocks-text-gray-900 rounded-3 px-2 py-1'>In person</span>
  }

  const provider = meetingUrl ? getSupportedProviderFromAdhocMeetingLink(meetingUrl) : undefined
  return <ProviderPill config={provider ? PROVIDER_CONFIG[provider] : undefined} />
}
